import { useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavigationContainerRef } from '@react-navigation/native';
import lodashIsEmpty from 'lodash/isEmpty';
import lodashIsEqual from 'lodash/isEqual';

import { setRoute } from '../RTK/utility';
import { selectRoute } from '../RTK/utility/selectors';

const useRouteIndex = () => {
  const dispatch = useDispatch();
  const navContainerRef = useRef<NavigationContainerRef<any>>(null);
  const savedRoute = useSelector(selectRoute);

  const _setRoute = useCallback(() => {
    if (navContainerRef.current) {
      const route = navContainerRef.current.getCurrentRoute();
      if (
        !lodashIsEmpty(route) &&
        (!lodashIsEqual(route?.name, savedRoute?.name) ||
          !lodashIsEqual(route?.params, savedRoute?.params))
      ) {
        dispatch(
          setRoute({
            name: route.name,
            params: route?.params,
          }),
        );
      }
    }
  }, [savedRoute?.name, savedRoute?.params, dispatch]);

  return {
    containerRef: navContainerRef,
    setRoute: _setRoute,
  };
};

export default useRouteIndex;
